import { render, staticRenderFns } from "./updated-m.vue?vue&type=template&id=0a4ac815&"
import script from "./updated-m.vue?vue&type=script&lang=js&"
export * from "./updated-m.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports